import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "出荷希望", enum: "IS_READY" },
  { value: 2, text: "移動予定日", enum: "MOVING_PLAN_DATE" },
  { value: 3, text: "配送指定日", enum: "SPECIFIED_DELIVERY_DATE" },
  { value: 4, text: "数量", enum: "MOVING_QUANTITY" },
]);
